<div *ngIf="visibleRdis.length > 0" class="rdi-section" fxLayout="column" fxLayoutGap="10px">
	<h3 class="rdi-section-header">{{ 'requiredDriverInputSectionView.sectionHeader' | translate }}</h3>

	<div class="rdi-table-scroll">
		<table class="rdi-table" [class.rdi-table--routed]="showStopType" mat-table [dataSource]="visibleRdis">
			<ng-container matColumnDef="prompt">
				<th mat-header-cell *matHeaderCellDef>{{ 'requiredDriverInputSectionView.promptColumnHeader' | translate }}</th>
				<td mat-cell *matCellDef="let rdi">{{ rdi?.label }}</td>
			</ng-container>

			<ng-container matColumnDef="stopType">
				<th mat-header-cell *matHeaderCellDef>{{ 'requiredDriverInputSectionView.stopTypeColumnHeader' | translate }}</th>
				<td mat-cell *matCellDef="let rdi">{{ rdi._stopTypeLabel }}</td>
			</ng-container>

			<ng-container matColumnDef="event">
				<th mat-header-cell *matHeaderCellDef>{{ 'requiredDriverInputSectionView.eventColumnHeader' | translate }}</th>
				<td mat-cell *matCellDef="let rdi">{{ rdi._eventLabel }}</td>
			</ng-container>

			<ng-container matColumnDef="inputType">
				<th mat-header-cell *matHeaderCellDef>{{ 'requiredDriverInputSectionView.inputTypeColumnHeader' | translate }}</th>
				<td mat-cell *matCellDef="let rdi">{{ rdi._inputTypeLabel }}</td>
			</ng-container>

			<ng-container matColumnDef="driverResponse">
				<th mat-header-cell *matHeaderCellDef>{{ 'requiredDriverInputSectionView.driverResponseColumnHeader' | translate }}</th>
				<td mat-cell *matCellDef="let rdi">
					<!-- rdi.value is a JSON id list for photo RDIs, so it is never printed directly. -->
					<ng-container *ngIf="rdi._isPhoto; else plainValue">
						<span *ngIf="rdi._hasPhotoAttachment; else photoNoAttachments" class="rdi-attachment-below">{{ 'requiredDriverInputSectionView.attachmentBelow' | translate }}</span>
						<ng-template #photoNoAttachments>—</ng-template>
					</ng-container>
					<ng-template #plainValue>{{ rdi?.value }}</ng-template>
				</td>
			</ng-container>

			<ng-container matColumnDef="completed">
				<th mat-header-cell *matHeaderCellDef>{{ 'requiredDriverInputSectionView.completedColumnHeader' | translate }}</th>
				<td mat-cell *matCellDef="let rdi">{{ rdi?.completedTimestamp?.formattedDate }} {{ rdi?.completedTimestamp?.formattedTime }} {{ rdi?.completedTimestamp?.timeZone }}</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		</table>
	</div>

	<div *ngIf="hasAnyPhotoRdi && photoAttachments.length > 0"
		 class="rdi-attachment-links" fxLayout="column" fxLayoutGap="8px">
		<div *ngFor="let attachment of photoAttachments" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
			<mat-icon>attachment</mat-icon>
			<a (click)="openFile(attachment)" *ngIf="access > 0 && attachment?.id"
			   [class.disabled]="isOpening$ | async" class="rdi-attachment-link">
				{{ attachment?.fileName }} - {{ attachment?.description }}
			</a>
			<small *ngIf="access === 0 || !attachment?.id">{{ attachment?.fileName }} - {{ attachment?.description }}</small>
			<app-download-file-combo-button *ngIf="access > 0 && attachment?.id"
											[fileType]="attachment._fileType"
											[id]="attachment.id"></app-download-file-combo-button>
		</div>
	</div>
</div>
